import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './FetchBaseQuery';

export const dashboardApi = createApi({
    reducerPath: 'dashboardApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Dashboard'],
    endpoints: (builder) => ({
        getTotalUsers: builder.query({
            query: () => `opportunity/count`,
            transformResponse: (res) => res.response.count,
        }),
        getEstimates: builder.query({
            query: () => `estimate/estimatecount`,
            transformResponse: (res) => res.response.count,
        }),
        getQuotations: builder.query({
            query: () => `quotation/quotationcount`,
            transformResponse: (res) => res.response.count,
        }),

        getDashboardQuotations: builder.query({
            query: ({ viewType, yearInput, fromYear, toYear }) => {
                if (viewType === 'specificYear') {
                    return {
                        url: `quotation/dashboard`,
                        params: {
                            type: 'specificYear',
                            yearInput,
                        },
                    };
                } else if (viewType === 'range') {
                    return {
                        url: `quotation/dashboard`,
                        params: {
                            type: 'range',
                            from: fromYear,
                            to: toYear,
                        },
                    };
                } else {
                    return {
                        url: `quotation/dashboard`,
                        params: {
                            type: 'specificYear',
                            yearInput: new Date().getFullYear(),
                        },
                    };
                }
            },
        }),

        getProposals: builder.query({
            query: () => `proposal/proposalcount`,
            transformResponse: (res) => res.response.count,
        }),
        getContracts: builder.query({
            query: () => `contract/contractcount`,
            transformResponse: (res) => res.response.count,
        }),

        getProposalStatistics: builder.query({
            query: ({ viewType, yearInput, fromYear, toYear }) => {
                const params =
                    viewType === "specificYear"
                        ? { year: yearInput }
                        : viewType === "range" && fromYear && toYear
                            ? { startYear: fromYear, endYear: toYear }
                            : {};

                return {
                    url: 'proposal/proposalstatistics',
                    params,
                };
            },
        }),

        getEstimateDashboard: builder.query({
            query: ({ viewType, yearInput, fromYear, toYear }) => {
                if (viewType === "specificYear") {
                    return {
                        url: "estimate/dashboard",
                        params: {
                            type: "year",
                            yearInput: yearInput,
                        },
                    };
                } else {
                    return {
                        url: "estimate/dashboard",
                        params: {
                            type: "range",
                            from: fromYear,
                            to: toYear,
                        },
                    };
                }
            },
        }),

        // Project Dashboard
        getProjectsDashboard: builder.query({
            query: ({ viewType, yearInput, fromYear, toYear }) => {
                const isSpecificYear = viewType === 'specificYear';

                return {
                    url: 'opportunity/project-graph',
                    params: {
                        type: isSpecificYear ? 'year' : 'range',
                        yearInput: isSpecificYear ? yearInput : undefined,
                        from: !isSpecificYear ? fromYear : undefined,
                        to: !isSpecificYear ? toYear : undefined,
                    },
                };
            },
        }),

        getContractsDashboard: builder.query({
            query: ({ viewType, yearInput, fromYear, toYear }) => {
                if (viewType === "specificYear") {
                    return {
                        url: "contract/dashboard",
                        params: {
                            type: "year",
                            yearInput: yearInput,
                        },
                    };
                } else {
                    return {
                        url: "contract/dashboard",
                        params: {
                            type: "range",
                            from: fromYear,
                            to: toYear,
                        },
                    };
                }
            },
        }),

    }),
});

export const {
    useGetTotalUsersQuery,
    useGetEstimatesQuery,
    useGetQuotationsQuery,
    useGetDashboardQuotationsQuery,
    useGetProposalsQuery,
    useGetContractsQuery,
    useGetProposalStatisticsQuery,
    useGetEstimateDashboardQuery,
    useGetProjectsDashboardQuery,
    useGetContractsDashboardQuery
} = dashboardApi;
